module.exports = __webpack_public_path__ + "img/wma.22721989.png";